import React, { FC, useEffect } from 'react';
import NoAffiliateAuthModal from '@common/noAffiliateAuthModal';
import { ContentsListItemVO } from '@domain/vo/common/ContentsListItemVO';
import ContentsListItem from '@components/common/contentsListItem';
import { PageState } from '@domain/rs/common/PageableRs';
import { usePostCardList } from '@repository/post/job/usePostJob';
import LoginModal from '@components/loginModal';
import { V2Route } from '@utils/routeUtil';
import useContentAccessControl from '@utils/hooks/useContentAccessControl';

interface Props {
  page: number;
  postCardSns: number[];
  setPageInfo: React.Dispatch<React.SetStateAction<PageState | null>>;
  category: string | number;
}

const InfoCardList: FC<Props> = ({ page, postCardSns, setPageInfo, category }) => {
  const { data: cardList } = usePostCardList(true, { page, size: 12, categorySns: postCardSns });

  const {
    handleCardClick,
    loginModalVisible,
    noAffiliateAuthModalVisible,
    redirectUrl,
    setLoginModalVisible,
    setNoAffiliateAuthModalVisible,
    noAffiliateAuthModalTitle,
  } = useContentAccessControl(`category=${category}`);

  useEffect(() => {
    if (!cardList) return;

    setPageInfo(cardList.pages[0].pages);
  }, [cardList, setPageInfo]);

  if (!cardList) return null;

  return (
    <>
      {cardList.pages.map((list) => {
        return list.posts.map((item) => {
          const contentData = new ContentsListItemVO({
            ...item,
            name: item.categoryName,
            tag: item.label,
            routeUrl: V2Route.getInfoDetailPage(item.sn),
          });

          return <ContentsListItem key={item.sn} contentData={contentData} handleClick={handleCardClick} />;
        });
      })}
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
      <NoAffiliateAuthModal
        title={noAffiliateAuthModalTitle}
        visible={noAffiliateAuthModalVisible}
        onClose={() => setNoAffiliateAuthModalVisible(false)}
      />
    </>
  );
};

export default InfoCardList;
